import { gql } from '@apollo/client';

export const GET_STAFFING_PROJECT_CONFIRMATION_DATA = gql`
  query GetStaffingProjectConfirmationData($id: ID!) {
    baseProject(id: $id) {
      id
      legacyId
      name
      alias
      projectManager
      budget {
        id
        startDate
        endDate
        softStartDate
        billingType
        fte
      }
      team {
        id
        location
        projectId
        type
        updatedAt
        expectedStructure {
          id
          teamId
          positionId
          technologyId
          competencyLevel
          requiredFte
          requiredRole
          description
        }
      }
      assignments {
        id
        employeeAlias
        positionId
        technologyId
        isBackup
        isSpof
        isBench
        projectId
        projectName
        fromDate
        toDate
        minPercent
        maxPercent
        isVirtual
        slotId
        status
        membershipRole
        competencyLevel
        isProbation
        noteText
      }
    }
  }
`;
